import { useMemo } from 'react'
import ListModule from '../../module/ListModule'
import { useAuth } from '../../../context/AuthContext'
import { useOutletContext } from 'react-router-dom'
import Loading from '../../common/Loading'
import { getTaxColumns } from './AccountingFields'
import { Box } from '@mui/material'

const ListTax = () => {
  const { user } = useAuth()
  const userRight = useOutletContext()

  const columns = useMemo(() => {
    return getTaxColumns()
  }, [])

  const options = useMemo(
    () => ({
      objectType: 'tax',
      accessRight: userRight,
      objectFilter: () => ({ company_id: user.company_id }),
      actions: {
        add: true,
        edit: true,
        view: true,
        delete: {
          message: 'Voulez-vous vraiment supprimer'
        }
      },
      showTotal: { display: true, label: 'Montant total', field: 'totalAmount', type: 'currency' },
      isExpand: false,
      columns
    }),
    [userRight, user.company_id, columns]
  )

  const toolbar = useMemo(
    () => ({
      objectType: 'tax',
      title: 'Cotisations URSSAF',
      accessRight: userRight,
      actions: {
        add: true
      },
      isFilter: true,
      columns: columns,
      columnVisibility: true
    }),
    [userRight, columns]
  )

  if (!columns.length)
    return (
      <Box
        sx={{
          display: 'flex',
          flex: 1,
          height: '100%',
          minHeight: '100px',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Loading />
      </Box>
    )
  return <ListModule options={options} toolbar={toolbar} />
}

export default ListTax
